import React from "react";
import UpArrowIcon from "../../Layout/Icons/UpArrowIcon";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { uploadArt } from "../../../actions";

class UploadImage extends React.Component {
  state = {
    fileSizeError: false,
  };

  onChangeFile = (e) => {
    if (e.target.files.length) {
      if (e.target.files[0].size < 8388608) {
        this.setState({
          fileSizeError: false,
        });
        this.props.uploadArt({
          type: this.props.type,
          file: e.target.files[0],
        });
      } else {
        this.setState({
          fileSizeError: true,
        });
      }
    }
  };

  render() {
    const introText =
        this.props.type === "photo" ? "photo/full color artwork" : "artwork",
      buttonText = this.props.type === "photo" ? "Photo/Full Color Art" : "Art",
      errorText = this.props.upload.error ? this.props.upload.error : null;

    return (
      <div className="upload__panel upload__panel--upload">
        <div>
          <h2 className="upload__panel__header">Upload your {introText}</h2>

          <form
            method="post"
            encType="multipart/form-data"
            className="upload__hidden-file-input"
          >
            <input
              type="file"
              name="files[art]"
              ref={(input) => {
                this.input = input;
              }}
              onChange={this.onChangeFile}
            />
          </form>

          <button
            onClick={() => {
              this.input.click();
            }}
            className={`button button--round button--upload`}
          >
            {!this.props.upload.isUploading && `Upload ${buttonText}`}

            {!this.props.upload.isUploading && <UpArrowIcon />}

            {this.props.upload.isUploading && `Uploading`}

            {this.props.upload.isUploading && (
              <ul className="submitting-spinner">
                <li className="submitting-spinner__dot submitting-spinner__dot--1" />
                <li className="submitting-spinner__dot submitting-spinner__dot--2" />
                <li className="submitting-spinner__dot submitting-spinner__dot--3" />
              </ul>
            )}
          </button>
        </div>

        {(errorText || this.state.fileSizeError) && (
          <div className="upload__error">
            <p>
              There was an error uploading{" "}
              <span className="placeholder">your file</span>.
            </p>
            <p>
              Please ensure that your file does not exceed{" "}
              <span className="placeholder">8mb</span>, and matches only the
              following extensions:{" "}
              <span className="placeholder">
                jpg, jpeg, bmp, gif, png, svg, tiff, pdf, ai, or eps
              </span>
              .
            </p>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    upload: state.upload,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadArt: uploadArt.request,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadImage);
